import Typography from "../../components/Typography/Typography";

const MenuItem = ({ icon: Icon, label, isActive, onClick, itemRef }) => {
  return (
    <div
      ref={itemRef}
      onClick={onClick}
      className="flex items-center gap-3 cursor-pointer hover:text-gray-800 transition-all"
    >
      <Icon size={16} color={isActive ? "#000" : "#7D7C78"} />
      <Typography size="16" weight="md" color={isActive ? "black" : "gray-600"}>
        {label}
      </Typography>
    </div>
  );
};

export default MenuItem;